import { useEffect, useState } from "react";

/**
 * ¿Hay una versión nueva de la app publicada? Compara el id de este build
 * (REACT_APP_BUILD_ID, lo fija craco.config.js al buildear) con
 * /version.json, que el mismo build deja en el sitio.
 *
 * Fase 0C de seguridad: antes de endurecer las reglas de Firestore, los
 * clientes viejos (que todavía escriben users/apartments directo) tienen que
 * recargar. Con `forzar: true` en version.json la recarga es automática al
 * volver a la pestaña.
 *
 * En desarrollo (sin REACT_APP_BUILD_ID) no hace nada.
 */
const INTERVALO_MS = 10 * 60 * 1000;

export function useVersionCheck() {
  const [nueva, setNueva] = useState(false);

  useEffect(() => {
    const actual = process.env.REACT_APP_BUILD_ID;
    if (!actual) return undefined;
    let vivo = true;
    let forzar = false;

    const consultar = async () => {
      try {
        const res = await fetch(`/version.json?ts=${Date.now()}`, { cache: "no-store" });
        if (!res.ok) return;
        const v = await res.json();
        if (!vivo || !v || !v.id || v.id === actual) return;
        forzar = v.forzar === true;
        setNueva(true);
      } catch (_) {
        // Sin red o sin version.json: se vuelve a intentar en el próximo foco.
      }
    };

    const alVolver = () => {
      if (document.visibilityState !== "visible") return;
      if (forzar) {
        window.location.reload();
        return;
      }
      consultar();
    };

    consultar();
    const timer = setInterval(consultar, INTERVALO_MS);
    document.addEventListener("visibilitychange", alVolver);
    window.addEventListener("focus", alVolver);
    return () => {
      vivo = false;
      clearInterval(timer);
      document.removeEventListener("visibilitychange", alVolver);
      window.removeEventListener("focus", alVolver);
    };
  }, []);

  return nueva;
}
